import { AlertTriangle, Clock } from 'lucide-react';

const ALERTS = [
  { id: 1, asset: 'srv-web-01', type: 'Port Scan', severity: 'high', message: 'Unauthorized port 8080 opened on web server', ts: '2 min ago' },
  { id: 2, asset: 'ws-finance-12', type: 'Config Drift', severity: 'medium', message: 'Firewall rule modified outside baseline', ts: '15 min ago' },
  { id: 3, asset: 'srv-db-01', type: 'Unauthorized Access', severity: 'critical', message: 'Root login attempt from unknown IP 45.33.32.156', ts: '28 min ago' },
  { id: 4, asset: 'fw-corp-01', type: 'Baseline Deviation', severity: 'low', message: 'New outbound rule added to production firewall', ts: '1 hour ago' },
  { id: 5, asset: 'srv-app-01', type: 'Service Change', severity: 'medium', message: 'New service registered: docker-registry', ts: '2 hours ago' },
  { id: 6, asset: 'printer-hq', type: 'New Device', severity: 'low', message: 'Unrecognized MAC address on VLAN 10', ts: '3 hours ago' },
  { id: 7, asset: 'srv-dc-01', type: 'Group Policy', severity: 'high', message: 'Domain admin group membership modified', ts: '4 hours ago' },
];

const SEV_STYLES = {
  critical: 'bg-red-500/20 text-red-400 border-red-500/30',
  high: 'bg-red-500/20 text-red-400 border-red-500/30',
  medium: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
  low: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
};

const ActiveAlerts = () => (
  <div className="p-6 space-y-6">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-white">Active Alerts</h1>
      <p className="text-sm text-gray-500 mt-1">
        Real-time notifications of unauthorized device changes · PRD: DRIFT (Section 7.7)
      </p>
    </div>

    <div className="bg-gray-900 border border-gray-700/50 rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-400" />
          <h2 className="text-lg font-semibold text-white">Drift Alerts</h2>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-xs text-gray-500 font-mono">{ALERTS.length} active</span>
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/20 text-cyan-400 border border-cyan-500/30">
            Coming Soon
          </span>
        </div>
      </div>

      <div className="space-y-2">
        {ALERTS.map((alert) => (
          <div
            key={alert.id}
            className="flex items-start justify-between px-4 py-3 bg-gray-950/60 rounded-lg border border-gray-800/60 hover:border-gray-700 transition-colors"
          >
            <div className="flex items-start gap-3">
              <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-mono font-bold uppercase border ${SEV_STYLES[alert.severity]}`}>
                {alert.severity}
              </span>
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-white">{alert.type}</span>
                  <span className="text-xs text-gray-500 font-mono">on {alert.asset}</span>
                </div>
                <p className="text-xs text-gray-500 mt-0.5">{alert.message}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <div className="flex items-center gap-1 text-xs text-gray-600">
                <Clock className="w-3 h-3" />
                <span>{alert.ts}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ActiveAlerts;
